import { render, staticRenderFns } from "./SourEdit.vue?vue&type=template&id=cbed4cf6&scoped=true&"
import script from "./SourEdit.vue?vue&type=script&lang=js&"
export * from "./SourEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbed4cf6",
  null
  
)

export default component.exports